import { render, staticRenderFns } from "./ExportLink.vue?vue&type=template&id=075e60ea"
import script from "./ExportLink.vue?vue&type=script&lang=js"
export * from "./ExportLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports